// @ts-ignore
const I18n = window.I18n

import {PAYMENT_METHOD_TYPE, TAKE_AWAY_NOT_PERMITTED} from "../../constants"


// @todo: This method is a mess, so we need to refactor a lot of things here and from CheckoutApp
export function  validateOrder(cart, deliverySlot, errors, isTakeAway: boolean, cartState, deliveryAddressState, cashSettings, paymentMethod: PAYMENT_METHOD_TYPE, phoneVerified: boolean) : true {

    if (!cart?.products || Object.keys(cart.products).length === 0) {
        throw new Error( I18n.t("cart_summary.empty_cart_alert"))
    }

    if (errors?.takeAway === TAKE_AWAY_NOT_PERMITTED) {
        throw new Error( I18n.t("cart_summary.takeaway_not_permitted"))
    }

    if (!phoneVerified) {
        throw new Error(I18n.t("cart_summary.phone_required_verified"))
    }

    if (!deliveryAddressState.street_number && !isTakeAway) {
        throw new Error(I18n.t("cart_summary.street_number_alert"))
    }

    if (!isTakeAway && !deliverySlot) {
        throw new Error(I18n.t("cart_summary.delivery_time_alert"))
    }

    // ADD TakeAwaySlot validation

    // TODO: Move validations away from here
    const payment_details = cartState.paymentMethod

    switch (paymentMethod) {
        case "cash":
            const cash_amount : undefined | string = payment_details.options.cash_amount

            if (isTakeAway === true) {
                // No validation needed, the customer can pay we any amount at the store
                break
            }

            if (!cash_amount || cash_amount === "") {
                throw new Error(I18n.t("cart_summary.cash_value_alert"))
            } else {
                // check amount > cartTotal
                const amount : number = Number(parseFloat(cash_amount).toFixed(2)) * 100 || 0

                let discountedTotal = cart.total
                if (amount < discountedTotal) {
                    throw new Error(I18n.t("cart_summary.cash_value_too_low_alert"))
                }
                // check amount - cart total < threshold
                let deliveryPrice = cartState.deliveryDetails?.price || 0
                let order_max_change = cashSettings.soft_threshold_cash_amount_cents
                if (amount - discountedTotal - deliveryPrice > order_max_change) {
                    let maxAmount = discountedTotal + deliveryPrice + order_max_change

                    const message = I18n.t("cart_summary.change_too_high_alert", {
                        max_value: (maxAmount / 100.0).toFixed(2),
                        change_value: order_max_change / 100.0,
                    })

                    throw new Error(message)
                }
            }

            break

        case "stripe":
            if (!payment_details.options.method) {
                throw new Error("Devi aggiungere o scegliere una carta di credito.")
            }
            break
        case "satispay":
            // No validation needed
            break
        case "wallet":
            // No validation needed
            break

        default:
            throw new Error("Metodo di pagamento non valido")
    }

    return true
}
